import * as React from "react"
import { useLocation, Link } from "react-router-dom"
import {
  SquareTerminal,
  User,
  BookOpen,
  type LucideIcon,
} from "lucide-react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { ProfileStrengthBadge } from "@/components/sidebar/profile-strength-badge"
import { useProfile } from "@/hooks/useProfile"

interface PlatformItem {
  title: string
  url: string
  icon: LucideIcon
  isActive?: boolean
}

export const NavPlatform = React.memo(function NavPlatform() {
  const location = useLocation()
  const { profileStrength, isLoading } = useProfile()

  const platformItems: PlatformItem[] = [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: SquareTerminal,
      isActive: location.pathname === "/dashboard" || location.pathname.startsWith("/dashboard/"),
    },
    {
      title: "Profile",
      url: "/profile",
      icon: User,
      isActive: location.pathname === "/profile",
    },
    {
      title: "Comprehension Assessment",
      url: "/assessment",
      icon: BookOpen,
      isActive: location.pathname === "/assessment",
    },
  ]

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {platformItems.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton asChild tooltip={item.title} isActive={item.isActive}>
              <Link to={item.url}>
                <item.icon className="h-4 w-4" />
                <span>{item.title}</span>
                {item.title === "Profile" && !isLoading && (
                  <ProfileStrengthBadge 
                    strength={profileStrength} 
                    className="ml-auto min-w-[60px] max-w-[80px] group-data-[collapsible=icon]:hidden"
                    showPercentage={true}
                  />
                )}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
});
